export const NetflixFooter = () => {
  const footerLinks = [
    {
      title: "Navigation",
      links: [
        { label: "Experience", href: "#experience" },
        { label: "Expertise", href: "#expertise" },
        { label: "Projects", href: "#projects" },
        { label: "Publications", href: "#publications" }
      ]
    },
    {
      title: "Connect", 
      links: [
        { label: "Email", href: "mailto:aakashvrma05@gmail.com" },
        { label: "LinkedIn", href: "https://www.linkedin.com/in/akashvermaufl" },
        { label: "Contact Form", href: "#contact" }
      ]
    },
    {
      title: "Recognition",
      links: [
        { label: "Awards & Recognition", href: "#awards" },
        { label: "Industry Publications", href: "#publications" },
        { label: "Leadership Roles", href: "#publications" },
        { label: "Certifications", href: "#awards" }
      ]
    }
  ];

  const scrollToSection = (href) => {
    if (href.startsWith('#')) {
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      window.open(href, '_blank');
    }
  };

  return (
    <footer className="netflix-footer">
      <div className="grid md:grid-cols-4 gap-8 mb-8">
        {/* Brand */}
        <div>
          <div className="netflix-logo mb-4">AKASH VERMA</div>
          <p className="text-netflix-gray-400 text-sm leading-relaxed">
            Strategic Technology Risk Leader with 15+ years transforming enterprise security 
            through innovative risk management and regulatory compliance.
          </p>
          <div className="mt-4">
            <span className="netflix-badge">Available for Leadership Roles</span>
          </div>
        </div>

        {/* Footer Links */}
        {footerLinks.map((section) => (
          <div key={section.title}>
            <h4 className="text-white font-semibold mb-3">{section.title}</h4>
            <ul className="space-y-2">
              {section.links.map((link) => (
                <li key={link.label}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-netflix-gray-400 hover:text-white transition-colors text-sm"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Bottom */}
      <div className="border-t border-netflix-gray-200 pt-6">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="text-netflix-gray-400 text-sm">
            © 2025 Akash Verma. Strategic Technology Risk Leader.
          </div>
          <div className="text-netflix-gray-400 text-sm mt-2 md:mt-0">
            Transforming Enterprise Security • Risk Management Excellence
          </div>
        </div>
      </div>
    </footer>
  );
};